import axios from "axios"
import { apiURL } from "@/config"
import { TRPM_TOKEN } from "@/utils/getWebserver"
let cancel
let promiseArr = {}
const CancelToken = axios.CancelToken
const isString = require("lodash.isstring")

axios.defaults.headers.common["TRPM-TOKEN"] = TRPM_TOKEN || ""
const Axios = axios.create({
  baseURL: apiURL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  timeout: 3000
})

// 请求拦截器
Axios.interceptors.request.use(
  config => {
    // 发起请求时，取消掉当前正在进行的相同请求
    if (promiseArr[config.url]) {
      promiseArr[config.url]("操作取消")
      promiseArr[config.url] = cancel
    } else {
      promiseArr[config.url] = cancel
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器即异常处理
Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "错误请求"
          break
        case 401:
          error.message = "未授权，请重新登录"
          break
        case 403:
          error.message = "拒绝访问"
          break
        case 404:
          error.message = "请求错误,未找到该资源"
          break
        case 405:
          error.message = "请求方法未允许"
          break
        case 408:
          error.message = "请求超时"
          break
        case 500:
          error.message = "服务器端出错"
          break
        case 501:
          error.message = "网络未实现"
          break
        case 502:
          error.message = "网络错误"
          break
        case 503:
          error.message = "服务不可用"
          break
        case 504:
          error.message = "网络超时"
          break
        case 505:
          error.message = "http版本不支持该请求"
          break
        default:
          error.message = `连接错误${error.response.status}`
      }
    } else {
      error.message = "连接到服务器失败"
    }
    return Promise.reject(error.message)
  }
)

export default {
  // get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      return Axios({
        method: "get",
        url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      })
        .then(res => {
          // 状态码根据需求填写
          if (res.data.status === 0) {
            // webserver 请求
            resolve(res.data)
          } else if (res.data.code === 0 && res.status === 200) {
            let data = isString(res.data.data)
              ? JSON.parse(res.data.data)
              : res.data.data
            resolve(data)
          } else {
            reject(res.data.status)
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  // post请求
  post(url, param) {
    return new Promise((resolve, reject) => {
      Axios({
        method: "post",
        url,
        data: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      })
        .then(res => {
          if (res.data.code === 0) {
            let data = isString(res.data.data)
              ? JSON.parse(res.data.data)
              : res.data.data
            resolve(data)
          } else {
            reject(res)
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
